import Vue from "vue";
import {API_HOST} from "@/settings/server";
import $store from "@/store";
import axios from "axios";

class BranchService{
    constructor() {
        this.cancelTokenSource = axios.CancelToken.source();
    }

    cancelRequests() {
        this.cancelTokenSource.cancel('GET requests canceled by the user.');
        this.cancelTokenSource = axios.CancelToken.source();
    }
    getBranches({inn}) {
        return Vue.axios.get(`${API_HOST}/api/branch`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                inn: typeof (inn) === 'string' ? inn : null
            },
            cancelToken: this.cancelTokenSource.token,
        });
    }
}

export default new BranchService();
